import {useRoutePayload} from '@github-ui/react-core/use-route-payload'

export interface WhitepapersConfirmationPayload {
  // Update this type to reflect the data you place in payload in Rails
  text: string
}
export function WhitepapersConfirmation() {
  const payload = useRoutePayload<WhitepapersConfirmationPayload>()
  return (
    <>
      <h1 data-hpc>Whitepaper Confirmation</h1>
      <article>{payload.text}</article>
    </>
  )
}

try{ WhitepapersConfirmation.displayName ||= 'WhitepapersConfirmation' } catch {}